<button
  mat-button
  class="pl-1 w-full text-left quick-filter-select"
  (click)="setFilter.emit()"
  [intercomTarget]="'quick-filter'"
>
  <div class="font-normal aligner-start w-full text-left">
    <y42-icon
      class="icon-quick-filter"
      *ngIf="state.icon"
      [ngStyle]="{ 'background-color': filter.background_color }"
      [ngClass]="filter.id"
      [iconStyle]="{
        color: filter.background_color === '#f4f4fb' || filter.background_color === '#fcfcfc' ? '#a6a6a6' : '#ffffff'
      }"
      [icon]="state.icon"
      [size]="filter.icon_width"
    ></y42-icon>
    <div class="ml-2 text-gray-700 truncate" [matTooltip]="filter.name">
      {{ filter.name }}
    </div>

    <button
      *ngIf="!isDefaultFilter"
      mat-icon-button
      class="small-icon-button edit-quick-filter"
      [matMenuTriggerFor]="settings"
      [intercomTarget]="'quick-filter-more'"
      (click)="$event.stopPropagation()"
    >
      <fa-icon class="fs-1 text-gray-700" [icon]="['fal', 'ellipsis-h']"></fa-icon>
    </button>
    <mat-menu #settings="matMenu" yPosition="below" xPosition="after">
      <button mat-menu-item (click)="editFilter.emit()">
        <fa-icon [icon]="['fal', 'pencil']"></fa-icon>&nbsp;&nbsp;Edit
      </button>
      <button mat-menu-item (click)="deleteFilter.emit()">
        <fa-icon [icon]="['fal', 'trash-alt']"></fa-icon>&nbsp;&nbsp;Delete
      </button>
    </mat-menu>
  </div>
</button>
